import { render, staticRenderFns } from "./Reg1920.vue?vue&type=template&id=3bd55dc4"
import script from "./Reg1920.vue?vue&type=script&lang=js"
export * from "./Reg1920.vue?vue&type=script&lang=js"
import style0 from "./Reg1920.vue?vue&type=style&index=0&id=3bd55dc4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports